import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconComment = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.23333 5H10.7667M4.23333 8H10.7667M14.5 6.56667C14.5 3.216 11.3659 0.5 7.5 0.5C3.63413 0.5 0.5 3.216 0.5 6.56667C0.5 9.91733 3.63413 12.6333 7.5 12.6333C7.99 12.6333 8.46787 12.5885 8.92987 12.5055L12.6333 14.5V10.6817C13.7888 9.6 14.5 8.15707 14.5 6.56667Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIconComment;
